import { render, staticRenderFns } from "./AxFrame.vue?vue&type=template&id=2945ba0a&scoped=true"
import script from "./AxFrame.vue?vue&type=script&lang=ts"
export * from "./AxFrame.vue?vue&type=script&lang=ts"
import style0 from "./AxFrame.vue?vue&type=style&index=0&id=2945ba0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2945ba0a",
  null
  
)

export default component.exports